import register from './register'
import signOut from './signout'
import getCurrentUserData from './getCurrentUserData'

const auth = {
    register,
    signOut,
    getCurrentUserData
}

export default auth